// extracted by mini-css-extract-plugin
module.exports = {"helpText":"TotpUserLoginHandler__helpText"};